<template>
  <div class="panel">
    <h3 class="my-0 text-2xl">
      {{ $t('sitesection.quick_select') }}
    </h3>
    <div
      v-for="cluster in clusters"
      :key="cluster.name"
      class="mb-3"
    >
      <div
        v-if="cluster.sites.length === 1"
        class="cursor-pointer my-2"
        @click="selectSite(cluster.sites[0])"
      >
        <Card :class="selectedId === cluster.sites[0].id ? 'selected-card' : 'card'">
          <template #title>
            <span class="text-base">{{ cluster.sites[0].name }}</span>
          </template>
          <template #content>
            <span class="text-sm font-light">
              {{ cluster.sites[0].address.name }}, {{ cluster.sites[0].address.postcode }} {{ cluster.sites[0].address.city }}
            </span>
          </template>
        </Card>
      </div>
      <div v-else>
        <h4
          class="cursor-pointer my-2 text-lg font-semibold hover:underline"
          @click="selectCluster(cluster)"
        >
          {{ cluster.name }}
        </h4>
        <div
          v-for="site in cluster.sites"
          :key="site.id"
        >
          <div
            class="cursor-pointer my-2 ml-4"
            @click="selectSite(site)"
          >
            <Card :class="selectedId === site.id ? 'selected-card' : 'card'">
              <template #title>
                <span class="text-base">{{ site.name }}</span>
              </template>
              <template #content>
                <span class="text-sm font-light">
                  {{ site.address.name }}, {{ site.address.postcode }} {{ site.address.city }}
                </span>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "primevue/card";

export default {
  name: "SiteSelectionPanelComponent",
  components: {Card},
  props: {
    sites: {
      type: Array,
      required: true
    }
  },
  emits: ['siteSelection', 'clusterSelection'],
  data() {
    return {
      selectedId: null
    }
  },
  computed: {
    clusters() {
      return this.groupSitesByCluster(this.sites);
    }
  },
  methods: {
    groupSitesByCluster(sites) {
      const clusterMap = new Map();

      for (const site of sites) {
        if (!clusterMap.has(site.cluster)) clusterMap.set(site.cluster, []);
        clusterMap.get(site.cluster).push(site);
      }

      return Array.from(clusterMap.entries())
        .map(([cluster, sites]) => ({
          name: sites.length === 1 ? sites[0].name : cluster,
          sites: sites.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        }))
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    },
    selectCluster(cluster) {
      this.$emit('clusterSelection', cluster);
    },
    selectSite(site) {
      this.selectedId = site.id;
      this.$emit('siteSelection', site);
    },
  }
}
</script>

<style scoped lang="scss">
.panel {
  max-height: 50vh;
  overflow-y: auto;
  background-color: $light-grey;
}

.card {
  border-image: none;
  border-left-width: 0;
  border-left-style: solid;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card:hover,
.selected-card {
  border-image: linear-gradient(to bottom, $gradient-left, $gradient-right) 1;
  border-left-width: 6px;
  border-left-style: solid;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

::v-deep(.p-card-body) {
  padding: 0.25rem 0.5rem !important;
}

::v-deep(.p-card-title) {
  margin-bottom: 0 !important;
}

::v-deep(.p-card-content) {
  padding: 0 !important;
}
</style>
